import { $ } from '@/libs/jquery/index'

$.validator.addMethod('cardamountdigits', function(value: string, element: HTMLElement): boolean {
  const parsed = value.replace(/\s/g, '')

  const cardLengths: number[] = [13, 16, 18, 19]

  return this.optional(element) || cardLengths.indexOf(parsed.length) !== -1
}, 'Некорректный формат номера карты')
